import { get } from '../utils/request';

export async function fetchData(data, options) {
  return await get('/dashboard/list.json', data, options);
}

export async function fetchDialogData(data, options) {
  return await get('https://query.aliyun.com/rest/aliyun_index.package-refund.rule', data, options);
}


// WEBPACK FOOTER //
// ./src/scripts/services/dashboardService.js